import React, { useEffect, useState } from "react";
import "./datatable.scss";
import { Space, Input, Button, Tag, Popover } from "antd";
import type { ColumnsType } from "antd/es/table";
import { EditOutlined, DeleteOutlined, PlayCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import { AppTable } from "../common";

interface Contentdata {
  key?: string;
  _id: number;
  id?: number;
  title: string;
  type: string;
  description: string;
  url: string;
  sheduledDate: string;
}

function DataTableLatestVideos({
  setshowModel,
  setEditable,
  isOpen,
  contentData,
  deleteOtherVideoContent,
  editContent,
  showModal,
}: any) {
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    console.log(contentData, "contentData");
  }, [contentData]);

  const columns: ColumnsType<Contentdata> = [
    {
      title: "ID",
      dataIndex: "_id",
      key: "_id",
      width: 60,
      filteredValue: [searchText],
      defaultSortOrder: "descend",
      sorter: (a: any, b: any) => (a._id || a.id || 0) - (b._id || b.id || 0),
      onFilter: (value, record) => {
        return (
          String(record.title).toLowerCase().includes(value.toLocaleString()) ||
          String(record._id || record.id).toLowerCase().includes(value.toLocaleString()) ||
          String(record.type).toLowerCase().includes(value.toLocaleString()) ||
          String(record.description)
            .toLowerCase()
            .includes(value.toLocaleString())
        );
      },
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (text) => (text && text.length > 15 ? `${text.slice(0, 100)}...` : text),
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: 90,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => (
        <>
          <p dangerouslySetInnerHTML={{ __html: text ? text.slice(0, 100) : "" }} />
        </>
      ),
    },
    {
      title: "Video",
      dataIndex: "url",
      key: "url",
      width: 150,
      render: (_, record) => (
        <a
          className="table_pill_btn table_pill_btn--view"
          href={record.url}
          target="_blank"
          rel="noreferrer"
        >
          <PlayCircleOutlined /> See Video
        </a>
      ),
    },
       {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => <div>{moment(text).format("DD-MM-YYYY hh:mm A")}</div>,
    },
    {
      title: "Status",
      dataIndex: "sheduledDate",
      key: "sheduledDate",
      // width: 80,
      render: (_, record) => (
        <Space size="middle">
          {record.sheduledDate === null ? (
            <Tag color={"green"}>Published</Tag>
          ) : moment().format("YYYY-MM-DD") >= record.sheduledDate ? (
            <Tag color={"green"}>Published</Tag>
          ) : (
            <Tag color={"red"}>Not Published</Tag>
          )}
        </Space>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            onClick={() => {
              setshowModel(!isOpen);
              setEditable(true);
              editContent(record._id || record.id);
            }}
            className="table_pill_btn table_pill_btn--view"
            icon={<EditOutlined />}
          >
            Edit
          </Button>
          <Popover
            content={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                }}
              >
                <Button
                  style={{
                    backgroundColor: "green",
                    width: "100%",
                    color: "#fff",
                  }}
                  onDoubleClick={() => deleteOtherVideoContent(record._id || record.id)}
                >
                  Yes
                </Button>
              </div>
            }
            title="Please Double click to delete."
          >
            <Button
              className="table_pill_btn table_pill_btn--danger"
              icon={<DeleteOutlined />}
            >
              Delete
            </Button>
          </Popover>
        </Space>
      ),
    },
  ];

  return (
    <div className="dataTable">
      <div className="filterMenu">
        <Button onClick={showModal} className="add_button">
          Add New Latest Video
        </Button>
        <Input.Search
          onSearch={(value) => {
            setSearchText(value);
          }}
          onChange={(e) => {
            setSearchText(e.target.value);
          }}
          className="searchField"
          placeholder="Search here..."
        />
      </div>
      <AppTable
        className="dataGrid"
        columns={columns}
        dataSource={contentData}
      />
    </div>
  );
}

export default DataTableLatestVideos;
